let screenWidth;
let screenHeight;
const siteBody = document.body;
const siteHeader = document.querySelector('header');

window.addEventListener('DOMContentLoaded', () => {
    screenWidth = document.body.clientWidth;
    screenHeight = window.innerHeight;
    cssRootVariable(siteBody, screenWidth, '--screen-width');
    cssRootVariable(siteBody, screenHeight, '--screen-height');
    cssRootVariable(siteBody, siteHeader, '--header-height');
    hashScroller('.scroll-to-hash');
    burgerToggle();
    // removeGreekAccents();
    // ShowMoreShowLess();
});

// * CHECK IF SCREEN RESIZING HAS ENDED
var rtime;
var timeout = false;
var delta = 200;

window.addEventListener('resize', () => {
    cssRootVariable(siteBody, screenHeight, '--screen-height');
    cssRootVariable(siteBody, screenWidth, '--screen-width');
    cssRootVariable(siteBody, siteHeader, '--header-height');

    rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeend, delta);
    }
});

let resizeend = () => {
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;
        // SCREEN RESIZING ENDS HERE - APPLY CHANGES BELOW
        screenWidth = document.body.clientWidth;
        screenHeight = window.innerHeight;
        cssRootVariable(siteBody, screenHeight, '--screen-height');
        cssRootVariable(siteBody, screenWidth, '--screen-width');
        cssRootVariable(siteBody, siteHeader, '--header-height');
    }
};

// Functions
let cssRootVariable = (scope, target, propertyName) => {
    if (target) {
        var value;
        if (typeof target === 'number') {
            value = target;
        } else {
            value = target.offsetHeight;
        }
        scope.style.setProperty(propertyName, `${value}px`);
    }
};

// toggle class with reset to default state
let hoverClassToggler = (parent, target, toggleClass) => {
    var defaultSelectedElement = 1;
    var wrapEl = document.querySelector(parent);
    var el = document.querySelectorAll(target);

    if (wrapEl) {
        for (var i = 0; i < el.length; i++) {
            el[i].onmouseenter = function () {
                for (var j = 0; j < el.length; j++) {
                    el[j].classList.remove(toggleClass);
                }
                this.classList.add(toggleClass);
            };
            el[i].onmouseleave = function () {
                this.classList.remove(toggleClass);
            };
        }
        wrapEl.onmouseleave = function () {
            el[defaultSelectedElement - 1].classList.add(toggleClass);
        };
    }
};

let hashScroller = (cl, xh) => {
    let scrollers = document.querySelectorAll(cl);
    scrollers.forEach((scroller) => {
        scroller.addEventListener('click', function (e) {
            e.preventDefault();
            headerHeight = document.querySelector('header').offsetHeight;
            $target = document.querySelector(this.href.substring(this.href.lastIndexOf('/') + 1));
            if (xh) {
                if (screenWidth >= 992) {
                    extraHeight = document.querySelector(xh).offsetHeight;
                    var hh = $target.getBoundingClientRect().top + window.scrollY - headerHeight - extraHeight - 55;
                } else {
                    extraHeight = document.querySelector(xh).offsetHeight;
                    var hh = $target.getBoundingClientRect().top + window.scrollY - headerHeight - extraHeight;
                }
            } else {
                var hh = $target.getBoundingClientRect().top + window.scrollY - headerHeight;
            }

            window.scrollTo({
                top: hh,
                behavior: 'smooth',
            });
        });
    });
};

let removeGreekAccents = () => {
    // Remove Greek Accents
    Array.from(document.querySelector("span, h1, h2, h3, h4, h5, h6, p, a, strong, td, button")).forEach((item) => {
        if(item.style.textTransform == 'uppercase') {
            item.innerHTML(item.innerHTML.replace(/[ά]/g, "α"));
            item.innerHTML(item.innerHTML.replace(/[έ]/g, "ε"));
            item.innerHTML(item.innerHTML.replace(/[ή]/g, "η"));
            item.innerHTML(item.innerHTML.replace(/[ύ]/g, "υ"));
            item.innerHTML(item.innerHTML.replace(/[ώ]/g, "ω"));
            item.innerHTML(item.innerHTML.replace(/[ί]/g, "ι"));
            item.innerHTML(item.innerHTML.replace(/[ό]/g, "ο"));
            item.innerHTML(item.innerHTML.replace(/[Ά]/g, "Α"));
            item.innerHTML(item.innerHTML.replace(/[Έ]/g, "Ε"));
            item.innerHTML(item.innerHTML.replace(/[Ή]/g, "Η"));
            item.innerHTML(item.innerHTML.replace(/[Ύ]/g, "Υ"));
            item.innerHTML(item.innerHTML.replace(/[Ώ]/g, "Ω"));
            item.innerHTML(item.innerHTML.replace(/[Ί]/g, "Ι"));
            item.innerHTML(item.innerHTML.replace(/[Ό]/g, "Ο"));
        }
    });
}

const ShowMoreShowLess = () => {
    const ShowMoreBtns = Array.from(document.getElementsByClassName('show-more-btn'))
    const ShowLessBtns = Array.from(document.getElementsByClassName('show-less-btn'))

    if(ShowMoreBtns){
        ShowMoreBtns.forEach(x => {
            x.addEventListener('click', () => {
                x.parentElement.parentElement.classList.add('active')
            })
        })
    }

    if(ShowLessBtns){
        ShowLessBtns.forEach(x => {
            x.addEventListener('click', () => {
                x.parentElement.parentElement.classList.remove('active')
            })
        })
    }
}

let burgerToggle = () => {
    let burger = document.querySelector('.document__header__burger');
    burger.addEventListener('click', function (e) {
        e.preventDefault();
        if (document.body.classList.contains('document-header--menu-open')) {
            headerSubMenuClosePassive();
        }
        document.querySelector('header').classList.toggle('document__header--menu-open');
        document.body.classList.toggle('document__header--menu-open'); // <- check this class
    });
};

// Contact Open Close CTA
document.getElementById('contactActivator').addEventListener('click', ()=>{
    document.body.classList.toggle('contact-active')
})
// Contact Open Close
document.getElementById('contactClose').addEventListener('click', ()=>{
    document.body.classList.toggle('contact-active')
})
// Close Contact or Menu click outside
document.querySelector('.body-cover').addEventListener('click', () => {
    document.body.classList.remove('contact-active' , 'document__header--menu-open')
    document.querySelector('header').classList.remove('document__header--menu-open')
})
// Close menu when you click on a menu item
document.querySelectorAll('.document__header__menu li a').forEach(x => {
    x.addEventListener('click', () => {
        document.body.classList.remove('contact-active' , 'document__header--menu-open')
        document.querySelector('header').classList.remove('document__header--menu-open')
    })
})
// Open contact + close menu on clicking contact menu CTA
document.querySelector('.contact-menu-item').addEventListener('click', () => {
    document.body.classList.add('contact-active')
    document.body.classList.remove('document__header--menu-open')
    document.querySelector('header').classList.remove('document__header--menu-open')
})